module.exports = __webpack_public_path__ + "static/media/tongyiliucheng.061bef7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/tongyiliucheng.mp4
// module id = aoAC
// module chunks = 0